import { Button, Card, Col, Form, Input, notification, Row, Space, Tabs } from "antd";
import React, { useContext, useEffect } from "react";
import SearchInput from "../../../components/SearchInput";
import IntegrationTab from "./IntegrationTab";
import { useParams, useSearchParams } from "react-router-dom";
import { requestGetProfile } from "../../../services/user.service";
import AppContext from "../../../store/app.context";

const TeamSettings = ({ teamId }) => {
	const { team, setUser, setTeam } = useContext(AppContext);
	const [searchParams, setSearchParams] = useSearchParams();
	const [activeTabKey, setActiveTabKey] = React.useState(searchParams.get("tab") || "general");

	useEffect(() => {
		document.title = "Pengaturan Tim - Cloudiva";
		fetchUserData();
	}, []);

	const fetchUserData = async () => {
		// fetch user data
		requestGetProfile().then((res) => {
			setUser(res.data.data);
			const teams = res.data.data.teams;

			// find current team by id
			const currentTeam = teams.find((team) => team._id === teamId);
			setTeam(currentTeam);
		});
	};

	return (
		<Card>
			<Tabs
				activeKey={activeTabKey}
				onChange={(key) => {
					setActiveTabKey(key);
					setSearchParams({ tab: key });
				}}
				type="card"
				size="middle"
				tabPosition="left"
				items={[
					{
						key: "general",
						label: "Pengaturan Umum",
					},
					{
						key: "billing",
						label: "Penagihan",
					},
					{
						key: "members",
						label: "Anggota Tim",
					},
					{
						key: "integrations",
						label: "Integrasi",
						children: <IntegrationTab team={team} message={searchParams.get("message")} />,
					},
				]}
			/>
		</Card>
	);
};

export default TeamSettings;
